import { ref, computed } from 'vue'
import store from '@/store'
import { config } from '@/config.js'

export default function usePlazosImpagados(context) {
    const loading = ref(false)

    const plazos = ref({
        data: [],
        meta: {}
    })

    const estadisticas = ref(null)

    const equipos = ref([])

    const filters = ref({
        per_page: 10,
        page: 1,
        estado: '',
        search: '',
        fecha_desde: '',
        fecha_hasta: '',
        equipo: []
    })

    const routeMap = {
        abonos: {
            list: 'back.plazos-impagados.abonos',
            stats: 'back.plazos-impagados.estadisticas.abonos'
        },
        bases: {
            list: 'back.plazos-impagados.bases',
            stats: 'back.plazos-impagados.estadisticas.bases'
        }
    }

    const routes = computed(() => routeMap[context] || routeMap.abonos)

    function updateFilter(key, value) {
        if (key in filters.value) {
            filters.value[key] = value
            if (key !== 'page') {
                filters.value.page = 1
            }
        }
    }

    async function fetchPlazos(listaId) {
        loading.value = true
        try {
            const params = {
                lista_id: listaId,
                filters: { ...filters.value }
            }
            const res = await store.dispatch(config.getVuexAlias(routes.value.list), params)
            plazos.value = res.data || { data: [], meta: {} }
        } catch (error) {
            console.error('Error fetching plazos:', error)
        } finally {
            loading.value = false
        }
    }

    async function fetchEstadisticas(listaId) {
        try {
            const params = {
                lista_id: listaId,
                filters: { ...filters.value }
            }
            const res = await store.dispatch(config.getVuexAlias(routes.value.stats), params)
            estadisticas.value = res.data?.data || res.data || null
        } catch (error) {
            console.error('Error fetching estadisticas:', error)
        }
    }

    async function fetchEquipos(listaId) {
        if (context !== 'bases') return
        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.get.equipos'),
                { lista_id: listaId }
            )
            equipos.value = res.data?.data ?? res.data ?? []
        } catch (error) {
            console.error('Error fetching equipos:', error)
        }
    }

    return {
        plazos,
        loading,
        estadisticas,
        equipos,
        filters,
        fetchPlazos,
        fetchEstadisticas,
        fetchEquipos,
        updateFilter
    }
}
